import { render } from "./StreamsViewer.vue?vue&type=template&id=349e878a"
import script from "./StreamsViewer.vue?vue&type=script&lang=js"
export * from "./StreamsViewer.vue?vue&type=script&lang=js"
script.render = render

export default script